import React, { useEffect, useState } from "react";
import { SlArrowUp, SlArrowDown } from "react-icons/sl";
import moment from "moment";
import "moment-timezone";
import { useBookingAtom, useClubAtom } from "../../Utilities/clubStore";
import { useTranslation } from "react-i18next";
import {
    calculateAvailability,
    getAllAvailableHours,
    getSelectableHours
} from "../../Api/api";
import { checkNullAndUndefined, formatCurrency, isEmpty } from "../../Utilities/utils";
import { CgSpinner } from "react-icons/cg";
import UserProfilePicOpenMatches from "../clubProfile/UserProfileOpenMatches";
import TourCardGameType from "../../widgets/bookingWidget/bookingModal/images/tourCardGameType.svg";
import TourCardBadge from "../../widgets/bookingWidget/bookingModal/images/tourCardBadge.svg";
import DownloadAppPopup from "../DownloadAppPopup";
import "../clubProfile/BookSlot.css";

interface ComponentBookingInfoProps {
    menuDivActive: boolean;
    pageSetter: any;
    day: string;
    date: string;
    time: string;
    onClose: () => void;
    setSelectedBookingData: any;
    jsonData: any;
    setPrice: any;
    setMins: any;
    endTime: any;
    startTime: any;
    key?: string;
    slotId?: string;
    slots?: any;
    setSelectedCourt: any;
    setAvailableSlotState: any;
    timezone: string;
    setStartTime: any;
    setEndTime: any;
    setBasePrice: any;
    basePrice: number;
    allSlots: any;
    originalCourts: any;
    isReservedBookings?: any;
    userData?: any;
    clubData?: any;
}

export const ComponentBookingInfo: React.FC<ComponentBookingInfoProps> = ({
    menuDivActive,
    pageSetter,
    day,
    date,
    time,
    onClose,
    jsonData,
    setPrice,
    setMins,
    key,
    slots,
    setSelectedBookingData,
    setSelectedCourt,
    setAvailableSlotState,
    timezone,
    setStartTime,
    setEndTime,
    basePrice,
    setBasePrice,
    allSlots,
    originalCourts,
    isReservedBookings,
    userData,
    clubData
}) => {
    const [loading, setLoading] = useState(false);
    const [showOpenMatches, setShowOpenMatches] = useState([]);
    const [isOpenAppDownloadModal, setIsOpenAppDownloadModal] = useState(false);
    const [courtDivActive, setCourtDivActive] = useState<boolean[]>();
    const [slotsLength, setSlotsLength] = useState(0);
    const [club, setClub] = useClubAtom();
    const [bookingAtom, setBookingAtom] = useBookingAtom();
    const [availableSlot, setAvailableSlot] = useState<any>({});
    const [updateSelectedSlot, setUpdateSelectedSlot] = useState<string>();

    useEffect(() => {
        // const hours = getSelectableHours(getAllAvailableHours([slots]));
        // const _availableSlot = calculateAvailability(
        //     slots.available_slots,
        //     time,
        //     hours
        // );
        setLoading(true);
        setAvailableSlot({});
        let newSlot = "";
        setShowOpenMatches([]);
        if (!checkNullAndUndefined(time) && time !== "") {
            const myArray = time.split(",");
            newSlot = myArray[1];
            setUpdateSelectedSlot(myArray[0]);
            if(isReservedBookings && isReservedBookings?.length > 0){
                const slotValue = myArray[0];
                const matchingBookings = getBookingsByStartTime(slotValue, isReservedBookings);
                if (matchingBookings && matchingBookings?.length > 0) {
                    setShowOpenMatches(matchingBookings);
                }  
            }
        }

        setTimeout(() => {
            const _availableSlot = getObjectsWithStartTime(
                allSlots,
                newSlot ? newSlot : time
            );

            if (_availableSlot) {
                setSlotsLength(getJsonKeyCount(_availableSlot));
                setAvailableSlot(_availableSlot);
                setCourtDivActive(
                    generateBooleanArray(getJsonKeyCount(_availableSlot))
                );
                setLoading(false);
            } else {
                setCourtDivActive(generateBooleanArray(slotsLength));
                setLoading(false);
            }
        }, 500);

        // setAvailableSlot(_availableSlot);

        // const isAvailable = Object.values(_availableSlot).some(
        //     (slot) => slot.isAvailable
        // );

        // if (isAvailable) {
        //     setCourtDivActive(false);
        // } else {
        //     setCourtDivActive(true);
        // }
    }, [time]);

    function closeAppDownloadModal() {
        setIsOpenAppDownloadModal(false);
    }

    function getBookingsByStartTime(timeHHmm: any, reservedBookings = []) {
        return reservedBookings.filter((booking: any) => {
        const bookingTime = moment
            .tz(booking?.start_datetime, timezone)
            .format("HH:mm");
        return bookingTime === timeHHmm;
        });
    }

    const getPlayerFromOpenMatch = (open_match: any, playerNumber: any) => {
        try {
        const playerData = open_match?.players?.[playerNumber];
        if (!playerData) return null;

        // If it's a valid JSON string, parse it
        if (typeof playerData === "string") {
            const fixed = playerData.replace(/'/g, '"');
            return JSON.parse(fixed);
        }

        // Already an object
        return playerData;
        } catch (error) {
        return null;
        }
    };

    function generateBooleanArray(length: number) {
        const booleanArray = [];
        for (let i = 0; i < length; i++) {
            booleanArray.push(true);
        }
        return booleanArray;
    }

    function getJsonKeyCount(_availableSlot: any) {
        // Initialize count
        let count = 0;

        // Loop through the object
        for (const key in _availableSlot) {
            count++;
        }
        return count;
    }

    function getObjectsWithStartTime(data: any, startTime: string) {
        const result: any = {};

        for (const obj of data) {
            if (obj.startTime === startTime) {
                if (!result[obj.courtName]) {
                    result[obj.courtName] = [];
                }
                result[obj.courtName].push(obj);
            }
        }

        return result;
    }

    const selectedDateTime = moment.tz(
        `${date} ${updateSelectedSlot}`,
        "DD/MM/YYYY HH:mm",
        timezone
    );

    const daySlotsExpired = selectedDateTime
        .tz(timezone)
        .isBefore(moment().tz(timezone));

    const foundSlot = slots?.available_slots?.find(
        (slot: any) => slot.hours?.includes(updateSelectedSlot)
    );

    const end = moment.tz(foundSlot?.end_datetime, timezone);
    const diff = end.diff(selectedDateTime, "minutes");

    const availableSlotOld: { [key: string]: boolean } = {
        "60": !daySlotsExpired && diff - 60 >= 0 && diff - 60 !== 30,
        "90": !daySlotsExpired && diff - 90 >= 0 && diff - 90 !== 30,
        "120": !daySlotsExpired && diff - 120 >= 0 && diff - 120 !== 30,
        "180": !daySlotsExpired && diff - 180 >= 0 && diff - 180 !== 30
    };
    const price = foundSlot?.price || 0;

    const toggleCourtClass = (index: number, value: boolean) => {
        if (!!courtDivActive) {
            const updatedState = [...courtDivActive]; // Create a copy of the state array
            updatedState[index] = value;
            setCourtDivActive(updatedState);
        }
    };

    const { t } = useTranslation();

    const getFacilities = (court: any) => {
        const facilities = [
            court.indoor ? t("indoor") : t("outdoor"),
            court.double ? t("double") : t("single"),
            court.sport.badminton ? t("Badminton") : "",
            court.sport.squash ? t("Squash") : "",
            court.sport.tennis ? t("Tennis") : "",
            court.sport.padel ? t("Padel") : "",
            court.sport.pickleball ? t("Pickleball") : ""
        ].filter((item) => item !== "");

        return facilities;
    };

    return (
        <>{loading ? <div className="flex justify-center items-center mt-4"><CgSpinner className="animate-spin text-[24px]" /></div> : <>
        {isReservedBookings && isReservedBookings?.length > 0 && showOpenMatches && showOpenMatches?.length > 0 && (
            <div>
                <p className="font-medium mt-4 text-xl">{t("openMatchesToJoin")}</p>
                <div className="flex gap-4 mt-4 overflow-x-auto no-scrollbar">
                    {showOpenMatches?.map((match: any, index) => {
                        const isDouble = match?.court_infos?.[0]
                        ? match.court_infos[0].double
                        : true;
                        const perPlayerPrice = (match?.total_price || 0) / (isDouble ? 4 : 2);
                        return (
                            <div key={index} onClick={()=>setIsOpenAppDownloadModal(true)} className="cursor-pointer rounded-[10px] shadow border border-[#000b29] border-opacity-[0.15] py-5 px-5 h-full min-w-fit mb-4">
                                <div className="flex flex-wrap gap-4 items-center">
                                    <div className="flex gap-2 items-center">
                                        <UserProfilePicOpenMatches
                                            player={getPlayerFromOpenMatch(
                                            match?.open_match,
                                            "player1"
                                            )}
                                            gameType={match?.sportType || "padel"}
                                            isRequested={false}
                                            playerNumber="player1"
                                            userData={userData}
                                        />
                                        {isDouble && (
                                        <UserProfilePicOpenMatches
                                            player={getPlayerFromOpenMatch(
                                            match?.open_match,
                                            "player2"
                                            )}
                                            gameType={match?.sportType || "padel"}
                                            isRequested={false}
                                            playerNumber="player2"
                                            userData={userData}
                                        />
                                        )}
                                    </div>
                                    <p>vs</p>
                                    <div className="flex gap-2 items-center">
                                        <UserProfilePicOpenMatches
                                            player={getPlayerFromOpenMatch(
                                            match?.open_match,
                                            "player3"
                                            )}
                                            gameType={match?.sportType || "padel"}
                                            isRequested={false}
                                            playerNumber="player3"
                                            userData={userData}
                                        />
                                        {isDouble && (
                                        <UserProfilePicOpenMatches
                                            player={getPlayerFromOpenMatch(
                                            match?.open_match,
                                            "player4"
                                            )}
                                            gameType={match?.sportType || "padel"}
                                            isRequested={false}
                                            playerNumber="player4"
                                            userData={userData}
                                        />
                                        )}
                                    </div>
                                </div>
                                <div className="mt-4 flex items-center gap-2">
                                    <div className="bg-secondary text-white rounded-xl px-3 py-1.5 capitalize text-xs w-fit flex items-center gap-2 h-7">
                                        <img
                                            src={TourCardGameType}
                                            alt="Badge"
                                            className="w-3 h-3 -mb-0.5"
                                        />
                                        {match?.sportType}
                                    </div>
                                    <div className="bg-secondary text-white rounded-xl px-3 py-1.5 uppercase text-xs w-fit flex items-center h-7">
                                        {formatCurrency(perPlayerPrice,clubData?.currency)}{"/p"}
                                    </div>
                                    <div className="bg-secondary text-white rounded-xl px-2 py-1 text-xs w-fit flex items-center gap-2 h-7">
                                        <img
                                            src={TourCardBadge}
                                            alt="Badge"
                                            className="w-3 h-3 -mb-0.5"
                                        />
                                        {`${match?.open_match?.min_level} - ${match?.open_match?.max_level}`}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )}
        {(menuDivActive && (checkNullAndUndefined(availableSlot) || isEmpty(availableSlot))) ? (<div>
            <p className="font-medium mt-6 text-lg">{t("availableCourts")}</p>
            <p className="font-medium mt-2 text-sm text-gray-400">{t("noAvailableCourtsForSelectedTime")}</p></div>) :
        <div className={menuDivActive ? "block w-full" : "hidden"}>
            {(!checkNullAndUndefined(availableSlot) || !isEmpty(availableSlot)) && <p className="font-medium mt-4 text-xl">{t("availableCourts")}</p>}
            {Object.keys(availableSlot).map((key, index) => {
                let courtData: any = {};
                let courtItem: any = {};
                originalCourts?.map((val: any) => {
                    if (val.name === key) {
                        courtData = getFacilities(val);
                        courtItem = val;
                    }
                });

                return (
                    <>
                        <hr className="w-full" />
                        <div className="flex justify-between gap-2 items-center mb-3 mt-[18px]">
                            <div className="flex flex-col">
                                <h3
                                    id="bookCourtName"
                                    className="text-[19px] font-semibold"
                                >
                                    {" "}
                                    {key}{" "}
                                </h3>
                                <p className="text-[15px]">
                                    {courtData?.join(" | ")}
                                </p>
                            </div>
                            <button className="mr-5">
                                {!!courtDivActive && !courtDivActive[index] ? (
                                    <SlArrowDown
                                        className="w-[22px] h-[22px] font-semibold"
                                        onClick={() =>
                                            toggleCourtClass(index, true)
                                        }
                                    />
                                ) : (
                                    <SlArrowUp
                                        className="w-[22px] h-[22px] font-semibold"
                                        onClick={() =>
                                            toggleCourtClass(index, false)
                                        }
                                    />
                                )}
                            </button>
                        </div>
                        {/* Find your ideal {day} Time Slot on {date} at {time} */}
                        {!!courtDivActive && courtDivActive[index] && (
                            <div
                                className={` ${
                                    !courtDivActive[index] ? "hidden" : "flex"
                                } flex-col gap-2 mt-3 mb-[18px]`}
                            >
                                {availableSlot[key]?.length ? (
                                    availableSlot[key]?.map(
                                        (item: any, inx: number) => (
                                            <div className="flex justify-between items-center gap-2 flex-wrap">
                                                <div className="flex flex-col">
                                                    <h5 className="font-medium text-lg">
                                                        {item?.duration} min
                                                    </h5>
                                                    <p className="text-[15px]">
                                                        {updateSelectedSlot} -{" "}
                                                        {moment(
                                                            updateSelectedSlot,
                                                            "HH:mm"
                                                        )
                                                            .add(
                                                                item?.duration,
                                                                "minutes"
                                                            )
                                                            .format("HH:mm")}
                                                    </p>
                                                </div>
                                                <div className="flex flex-col gap-3">
                                                    <button
                                                        id={`bookingPrice-${index}-${inx}`}
                                                        className="bg-secondary text-white text-[17px] px-4 py-2 min-w-[164px] min-h-[40px] rounded-2xl flex items-center justify-center font-semibold hover:bg-primary hover:text-secondary transform duration-200"
                                                        onClick={() => {
                                                            // debugger

                                                            setSelectedBookingData(
                                                                jsonData
                                                            );
                                                            setClub({
                                                                ...club,
                                                                startTime:
                                                                    availableSlotOld.start_datetime,
                                                                endTime:
                                                                    availableSlotOld.end_datetime
                                                            });
                                                            const formattedDate =
                                                                moment(
                                                                    date,
                                                                    "DD-MM-YYYY"
                                                                ).format(
                                                                    "YYYY-MM-DD"
                                                                );
                                                            localStorage.setItem(
                                                                "selectedDate",
                                                                formattedDate
                                                            );
                                                            setBookingAtom({
                                                                ...bookingAtom,
                                                                page: 1,
                                                                availableSlotState:
                                                                    availableSlotOld,
                                                                selectedCourt:
                                                                    courtItem,
                                                                startTime:
                                                                    moment(
                                                                        updateSelectedSlot,
                                                                        "HH:mm"
                                                                    ).format(
                                                                        "HH:mm"
                                                                    ),
                                                                endTime: moment(
                                                                    updateSelectedSlot,
                                                                    "HH:mm"
                                                                )
                                                                    .add(
                                                                        item?.duration,
                                                                        "minutes"
                                                                    )
                                                                    .format(
                                                                        "HH:mm"
                                                                    ),
                                                                show: !bookingAtom.show,
                                                                basePrice:
                                                                    item?.price,
                                                                price: Number(
                                                                    item?.price
                                                                ),
                                                                mins: item?.duration,
                                                                clubActivity:
                                                                    item
                                                            });
                                                        }}
                                                    >
                                                        {t("book")}{" "}
                                                        {formatCurrency(
                                                            item?.price?.toFixed(
                                                                2
                                                            ),
                                                            jsonData?.currency
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    )
                                ) : (
                                    <>
                                        <p>
                                            {t("noAvailableSlotFor")}{" "}
                                            <b>{updateSelectedSlot}</b>{" "}
                                        </p>
                                        <p>{t("selectAnotherDate")}</p>
                                    </>
                                )}
                            </div>
                        )}
                    </>
                );
            })}
        </div>}
        </>}
        <DownloadAppPopup
            isOpenAppDownloadModal={isOpenAppDownloadModal}
            closeAppDownloadModal={closeAppDownloadModal}
        />
        </>
    );
};
